import axios from "axios";
import Config from "../config";
import { ListProps } from "../components/PreviewSourceModal/servers";
export interface BaseTeamProps {
    courseNo: string;
    courseSeq: string;
    batchNo: string;
}
export interface BaseTeamPropsByWid extends BaseTeamProps {
    weektimeId: number;
    customerCode?: string;
}
export enum TeamCanType {
    no = "0",
    yes = "1"
}
export enum GroupType {
    Static = "0",
    Random = "1"
}
export const FILETYPE_LIST: Record<string, string[]> = {
    ppt: ["ppt", "pptx"],
    word: ["doc", "docx"],
    excel: ["xls", "xlsx"],
    pdf: ["pdf"],
    href: ["html"],
    pic: ["png", "jpg", "jpeg", "gif"],
    txt: ["txt", "csv"],
    video: ["ogg", "mp4", "mp3", "webm"],
    compression: ["rar", "7z", "zip"]
};

//todo new
//查询小组活动列表
export enum ActStatusType {
    All = "",
    ToBeInvolved = "0",
    ToBeSubmitted = "1",
    Submitted = "2"
}

const RequestConfig = {
    headers: { "Content-Type": "application/json" }
};

export interface GroupPersonItem {
    id: number;
    className: string; //成员所属班级名称
    major: string; //成员专业
    college: string; //成员所属院系
    isGroupLeader: BooleanValue; //是否小组长
    name: string; //姓名
    memberNo: string; //学号
}

//获取固定小组

export interface GetGroupProps extends BaseTeamProps {
    keyword: string;
}
export interface GroupItem {
    groupMemberList: GroupPersonItem[];
    id: number; //小组id
    groupName: string; //小组名称
    memberCount: number; //成员数量
}
export function myFixGroup(data: GetGroupProps) {
    return axios
        .post<SuccessData<GroupItem>>(
            `/student/myFixGroup`,
            data,
            RequestConfig
        )
        .then(res => (res.data?.data ? [res.data.data] : null));
}
//随机小组
export function myRandomGroup(data: GetGroupProps) {
    return axios
        .post<SuccessData<GroupItem[]>>(
            `/student/myRandomGroup`,
            data,
            RequestConfig
        )
        .then(res => res.data.data);
}

//小组活动小红点
export function hasPartInAllActivity(data: BaseTeamPropsByWid) {
    const customerCode = Config.CustomCode;

    return axios
        .post<SuccessData<any>>(
            `/student/hasPartInAllActivity`,
            {
                ...data,
                customerCode
            },
            RequestConfig
        )
        .then(res => res.data.message);
}

//获取小组活动列表
export interface ActivityInfo {
    id: number; //活动id
    activityName: string; //活动名称
    deadline: string; //截止日期
    deadlineStr: string; //截止日期字符串(yyyy-MM-dd MM:mm:ss)
    groupType: GroupType; //小组类型 0固定 1随机
    groupIds: string; //活动小组id列表
    needTaskAllocation: BooleanValue; //需要提交小组成员任务分配 0否1是
    onlySupportTeacherGrade: BooleanValue; //仅支持教师评分 0否1是
    onlySupportTeacherRemark: BooleanValue; //仅支持教师评语 0否1是
    publishStatus: BooleanValue; //发布状态 0否1是
    customerCode: string; //租户代码
    batchNo: string; //学期编号
    courseNo: string; //课程编号
    courseSeq: string; //课程序号
    weektimeId: number; //周次节id
}
export enum UploadType {
    Question = "0",
    Response = "1"
}
export interface TaskFileEntityList extends ListProps {
    taskHomeworkId?: number; //    所属任务id
    uuid?: string;
    delStatus?: number;
    uploadType?: string;
}
export interface TaskInfo {
    taskFileEntityList: TaskFileEntityList[];
    id: number; //    任务id
    activityId: number; //    活动id
    taskName: string; //    任务名称
    taskQuestion: string; //    任务问题
    groupIds: string; //    任务小组id列表，用,号隔开
    groupNames: string; //    任务小组名称列表，用,号隔开
    score: number; //    任务分数
}
export interface StatusInfo {
    id: number; //    活动状态id
    activityId: number; //    活动id
    taskId: number; //    任务id
    groupId: number; //    小组id
    memberId: number; //    组长id
    hasCorrected: BooleanValue; //    是否已批阅0否1是
    finished: BooleanValue; //    活动是否已结束 0否1是
    status: ActStatusType; //    小组活动状态：0待参与 1待提交 2已参与
}
export interface GroupActivityList {
    activityId: number; //    活动id
    taskId: number; //    任务id
    groupId: number; //    小组id
    groupType: GroupType;
    groupLeaderNo: string; //    小组长学号
    canEdit: BooleanValue; //    是否可以编辑
    courseNo: null; //    课程编号
    courseSeq: null; //    课程序号
    batchNo: null; //    学期编号
    activityInfo: ActivityInfo;
    taskInfo: TaskInfo;
    statusInfo: StatusInfo;
}
export function queryMyGroupActivityList(
    data: BaseTeamPropsByWid & {
        statusQuery: ActStatusType;
    }
) {
    return axios
        .post<SuccessData<GroupActivityList[]>>(
            `/student/queryMyGroupActivityList`,
            data,
            RequestConfig
        )
        .then(res => res.data.data);
}

//小组活动详情
export interface GetGroupDetailProps {
    groupType: GroupType;
    groupLeaderNo: string; //组长学号
    groupId: number; //小组id
    taskId: number; //任务id
    activityId: number; //活动id
}
export interface HomeworkInfo {
    homeworkFileList: TaskFileEntityList[];
    id: number; //    小组作业id
    activityId: number; //    小组活动id
    taskId: number; //    小组任务id
    groupId: number; //    小组id
    answerMemberNo: string; //    回答成员学号（小组长学号）
    taskAnswer: string; //    回答
    score: number; //    小组作业得分
    remark: string; //    小组作业评语
}
export interface MemberGradeInfo {
    id: number; //   我的成员分数id
    activityId: number; //   小组活动id
    taskId: number; //   小组任务id
    groupId: number; //   小组id
    memberId: number; //   我的成员id
    groupScore: number; //   我的小组得分
    memberScore: number; //   我的成员得分
}
export interface GroupActivityDetail extends GroupActivityList {
    homeworkInfo: HomeworkInfo;
    memberGradeInfo: MemberGradeInfo;
}
export function queryGroupActivityDetail(data: GetGroupDetailProps) {
    return axios
        .post<SuccessData<GroupActivityDetail>>(
            `/student/queryGroupActivityDetail`,
            data,
            RequestConfig
        )
        .then(res => res.data.data)
        .then(res => {
            if (res?.homeworkInfo?.homeworkFileList) {
                res.homeworkInfo.homeworkFileList =
                    res?.homeworkInfo?.homeworkFileList?.map(file => {
                        if (file.uuid && !file.id) {
                            file.id = file.uuid;
                        }
                        return file;
                    });
            }
            if (!res?.homeworkInfo?.homeworkFileList) {
                res.homeworkInfo.homeworkFileList = [];
            }
            if (!res?.taskInfo?.taskFileEntityList) {
                res.taskInfo.taskFileEntityList = [];
            }
            return res;
        });
}

//保存
export interface BaseSaveProps {
    activityId: number; //    活动id
    taskId: number; //    任务id
    groupId: number; //    小组id
}
export interface SaveProps extends BaseSaveProps {
    homeworkFileList: TaskFileEntityList[];
    answerMemberNo: string; //    回答人学号（小组长学号）
    taskAnswer: string; //    回答
}
export function saveGroupAnswer(data: SaveProps) {
    return axios
        .post<SuccessData<GroupActivityDetail>>(
            `/student/saveGroupAnswer`,
            data,
            RequestConfig
        )
        .then(res => res.data.data);
}

//提交
export function submitGroupHomework(data: BaseSaveProps) {
    return axios
        .post<SuccessData<GroupActivityDetail>>(
            `/student/submitGroupHomework`,
            data,
            RequestConfig
        )
        .then(res => res.data.data);
}
